import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import { PunditUserContextProvider } from "@circle-react/contexts/punditUserContext";
import { I18nProvider } from "@circle-react/providers/I18nProvider";
import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { createQueryConfig } from "@circle-react/providers/QueryClient/reactQueryConfig";
import { ThemeProvider } from "@circle-react/providers/Theme/ThemeProvider";
import { CompassProvider } from "@circleco/compass/context/CompassProvider";
import { StrictMode } from "react";
import { QueryClient } from "react-query";

import { FormRenderer } from "@/react/components/FormRenderer";
import type { RenderType } from "@/react/components/FormRenderer/contexts/FormRenderingContext";
import type { FormEmbedDisplayFormat } from "@/react/types/Form";

const provider = new QueryClient(createQueryConfig());

interface FormsAppProps {
  embed_display_format?: FormEmbedDisplayFormat;
  id: number;
  index: number;
  is_preview?: boolean;
  is_used_on_pages?: boolean;
  popup_delay?: number;
  popup_frequency?: number;
  renderType?: RenderType;
}

export const FormsApp = ({
  id,
  index,
  is_preview = false,
  is_used_on_pages = false,
  embed_display_format,
  popup_frequency,
  popup_delay,
  renderType,
}: FormsAppProps) => (
  <StrictMode>
    <CompassProvider>
      <I18nProvider>
        <QueryClientProvider client={provider}>
          <PunditUserContextProvider>
            <ThemeProvider>
              <ModalManagerProvider>
                <FormRenderer
                  id={id}
                  index={index}
                  isPreview={is_preview}
                  usage={is_used_on_pages ? "page" : undefined}
                  embedDisplayFormat={embed_display_format}
                  popupFrequency={popup_frequency}
                  popupDelay={popup_delay}
                  renderType={renderType}
                />
              </ModalManagerProvider>
            </ThemeProvider>
          </PunditUserContextProvider>
        </QueryClientProvider>
      </I18nProvider>
    </CompassProvider>
  </StrictMode>
);
